<script>
    import { link, navigate } from "svelte-routing";
    import { onMount } from "svelte";
    import Loader from "../components/Modal/Loader.svelte";
    import { post, get, patch } from "../utils/rest";

    let email;
    let password;
    let waitforResponse = false;
    let logemail;
    onMount(async () => {
       logemail =  localStorage.getItem("email");
      if(logemail){
          console.log("Checking:::"+logemail)
          navigate("/orders-dashboard", { replace: true });
      } 
    })
    $: logemail = logemail;

    function validate() {
        waitforResponse = true;
        let uservalue = {
            email: email,
            password: password,
        };
        console.log("uservalue::::" + JSON.stringify(uservalue));
        post(
            "https://kalaputriartbackend.herokuapp.com/admin/login",
            uservalue,
            function (err, result) {
                let response = result;
                let userResponse = {
                    email: result.data.user.email,
                    firstname: result.data.user.firstname,
                    lastname: result.data.user.lastname,
                    token: result.data.token,
                    isActive: result.data.user.isActive,
                    role: result.data.user.roles[0].name,
                };
                localStorage.setItem(
                    "username",
                    userResponse.firstname + " " + userResponse.lastname
                );
                if (userResponse.firstname == "Spandana") {
                    localStorage.setItem(
                        "profile",
                        "https://res.cloudinary.com/kalaputri/image/upload/v1612701211/Email/WhatsApp_Image_2021-02-07_at_6.03.00_PM_vchd1p.jpg"
                    );
                } else if (userResponse.firstname == "Akhil") {
                    localStorage.setItem(
                        "profile",
                        "https://res.cloudinary.com/kalaputri/image/upload/v1612701208/Email/WhatsApp_Image_2021-02-07_at_5.57.08_PM_uvrec6.jpg"
                    );
                }
                localStorage.setItem("email", userResponse.email);
                localStorage.setItem("token", userResponse.token);
                waitforResponse = false;
                navigate("/orders-dashboard", { replace: true });
            }
        );
    }
</script>

<svelte:head>
    <title>KalaPutri-ArtOrders</title>
</svelte:head>
<Loader loading={waitforResponse} />
<div class="content">
    <div class="container">
        <div class="row">
            <div class="col-md-6 order-md-2">
                <!-- svelte-ignore a11y-img-redundant-alt -->
                <img
                    src="images/undraw_file_sync_ot38.svg"
                    alt="Image"
                    class="img-fluid"
                />
            </div>
            <div class="col-md-6 contents">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="mb-4">
                            <h3>Sign In to <strong>KalaPutri</strong></h3>
                            <p class="mb-4">
                                Kalaputri arts Order Booking Portal
                            </p>
                        </div>
                        <form action="#" method="post">
                            <div class="form-group first">
                                <label for="email">Email</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    bind:value={email}
                                    id="email"
                                />
                            </div>
                            <div class="form-group last mb-4">
                                <label for="password">Password</label>
                                <input
                                    type="password"
                                    bind:value={password}
                                    class="form-control"
                                    id="password"
                                />
                            </div>

                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                on:click={() => validate()}
                                use:link
                                class="btn text-white btn-block btn-primary"
                            >
                                Log In
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
</style>
